import apiClient from './index';

export type DeviceDocument = {
  id: string;
  device_id: string;
  uploaded_by_user_id?: string | null;
  document_type: string;
  storage_bucket: string;
  storage_key: string;
  file_name: string;
  content_type?: string | null;
  size_bytes?: number | null;
  created_at?: string | null;
};

export type DeviceDocumentPresignResponse = {
  upload_url: string;
  storage_bucket: string;
  storage_key: string;
  expires_in: number;
};

export const deviceDocumentsApi = {
  async list(deviceId: string): Promise<DeviceDocument[]> {
    const res = await apiClient.get<DeviceDocument[]>(`/devices/${deviceId}/documents`);
    return res.data;
  },

  async createPresign(
    deviceId: string,
    payload: {
      file_name: string;
      document_type: string;
      content_type?: string | null;
      size_bytes?: number | null;
    }
  ): Promise<DeviceDocumentPresignResponse> {
    const res = await apiClient.post<DeviceDocumentPresignResponse>(
      `/devices/${deviceId}/documents/presign`,
      payload
    );
    return res.data;
  },

  async create(
    deviceId: string,
    payload: {
      document_type: string;
      storage_bucket: string;
      storage_key: string;
      file_name: string;
      content_type?: string | null;
      size_bytes?: number | null;
    }
  ): Promise<DeviceDocument> {
    const res = await apiClient.post<DeviceDocument>(`/devices/${deviceId}/documents`, payload);
    return res.data;
  },

  async getDownloadUrl(deviceId: string, documentId: string): Promise<{ download_url: string; expires_in: number }> {
    const res = await apiClient.get<{ download_url: string; expires_in: number }>(
      `/devices/${deviceId}/documents/${documentId}/download`
    );
    return res.data;
  },

  async remove(deviceId: string, documentId: string): Promise<void> {
    await apiClient.delete(`/devices/${deviceId}/documents/${documentId}`);
  },
};
